
import * as antIcons from '@ant-design/icons-vue';
import {isUrl} from '../../util.js';

export default {
  name: 'EleProSidebarMenus',
  components: {...antIcons},
  emits: ['openChange'],
  props: {
    // 菜单数据
    data: Array,
    // 导航模式
    mode: String,
    // 主题, light | dark
    theme: String,
    // 展开的key
    openKeys: Array,
    // 选中的key
    selectedKeys: Array,
    // 子级缩进
    inlineIndent: Number,
    // 是否折叠
    inlineCollapsed: Boolean,
    // 一级pop菜单class
    firstPopClass: String
  },
  methods: {
    /* 子级展开事件 */
    onOpenChange(e) {
      this.$emit('openChange', e);
    },
    /* 是否有子级 */
    haveChildren(item) {
      return !!(item.children && item.children.filter((d) => !d.meta.hide).length);
    },
    /* 是否是网址 */
    isUrl(item) {
      return isUrl(item.path);
    }
  }
}
